"use client";

import { GridCard } from "@entities/common";
import { TCommonGridSection } from "@shared/cms";
import { Subtitle } from "@shared/ui";

export function CommonGridSection({ title, subtitle, cards }: TCommonGridSection) {
  return (
    <section className="py-14 md:py-24">
      <div className="container">
        <div className="space-y-4 text-grey-700 text-center max-w-[552px] mx-auto">
          {subtitle && <Subtitle {...subtitle} containerClass="justify-center" />}
          <h2 className="text-2xl sm:text-4xl font-bold text-gray-700">{title}</h2>
        </div>
        {cards && cards.length > 0 && (
          <div className="mt-8 sm:mt-12 grid md:grid-cols-3 gap-x-14 gap-y-8">
            {cards.map((card) => {
              return <GridCard key={card.id} {...card} />;
            })}
          </div>
        )}
      </div>
    </section>
  );
}
